import * as R from 'ramda'

import { stringify } from 'utils/json'

export const getCategories = R.pipe(
  R.values,
  R.pluck('category'),
  R.filter(R.identity),
  R.sort(R.comparator(R.lt)),
  R.uniq,
  R.memoizeWith(stringify, R.identity),
)
